import template from "./pD365Interrupts.html";

export function pD365InterruptsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pD365InterruptsController,
    controllerAs: 'pD365Interrupts',
    bindToController: true
  };

  return directive;
}

class pD365InterruptsController {
  constructor($scope, $interval, $translate, Auth, Notes, D365, Sort, Utils) {
    'ngInject';
    this.$scope = $scope;
    this.$interval = $interval;
    this.$translate = $translate;

    this.Auth = Auth;
    this.Notes = Notes;
    this.D365 = D365;
    this.Sort = Sort;
    this.Utils = Utils;

    this.state = "loading";
    this.matchBlocked = false;

    this.headers = [
      {name: "D365.CLIENT_KLIX", class: "table-info"},
      {name: "D365.CLIENT_D365", class: "table-d365"}
    ];

    this.interruptSearchPlaceholder = this.$translate.instant('D365.INTERRUPT_SEARCH_PLACEHOLDER');
    this.interruptSearchTooltip = this.$translate.instant('D365.INTERRUPT_SEARCH_TOOLTIP');

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 200);
        this.$scope.$on("$destroy", () => {
          this.$interval.cancel(timeout);
        });
        this.getData();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  mapInterrupt(mappers, interrupt, appliesToClient) {
    const mappedInterrupt = mappers.find(mapper => mapper.id === interrupt.id && mapper.appliesToClient === appliesToClient);

    return {
      interruptId: interrupt.id,
      interruptName: interrupt.name,
      d365InterruptName: mappedInterrupt && mappedInterrupt.d365InterruptName,
      d365InterruptId: mappedInterrupt && mappedInterrupt.d365InterruptId,
      d365HierarchyId: mappedInterrupt && mappedInterrupt.d365HierarchyId,
      appliesToClient,
      unmatched: !mappedInterrupt
    };
  }

  getData() {
    this.D365.getInterrupts().then(
      (response) => {
        this.interruptsWithoutClient = response.data.interrupts.filter(interrupt => !interrupt.hasClient || interrupt.hasServiceLine).sort(this.Sort.abcBy("name"));

        if (this.interruptsWithoutClient.length === 0)
          this.noInterruptsWhitouthClient = true;
        else
          this.interruptsWithoutClientMapperToDisplay = this.interruptsWithoutClient.map(interrupt => this.mapInterrupt(response.data.mappers, interrupt, false));

        this.interruptsWithClient = response.data.interrupts.filter(interrupt => interrupt.hasClient).sort(this.Sort.abcBy("name"));

        if (this.interruptsWithClient.length === 0)
          this.noInterruptsWithClient = true;
        else
          this.interruptsWithClientMapperToDisplay = this.interruptsWithClient.map(interrupt => this.mapInterrupt(response.data.mappers, interrupt, true));

        this.state = "loaded";
      },
      (error) => {
        this.state = "loaded";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  editInterrupt(entity, mappers) {
    this.matchBlocked = this.Utils.blockMatch(mappers);
    this.interruptToMatch = {id: entity.d365InterruptId, name: entity.d365InterruptName, ...entity};
    this.hintInterrupt = entity.interruptName.substr(0, entity.interruptName.indexOf(' ') + 1);
  }

  getInterruptsD365(query) {
    return this.D365.getInterruptsD365(query).then(
      (success) => {
        return success.data.map(interrupt => ({
          d365InterruptName: interrupt.name,
          d365InterruptId: interrupt.taskId,
          d365HierarchyId: interrupt.hierarchyId
        }));
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
        return [];
      }
    );
  }

  selectInterrupt(interrupt) {
    this.interruptToMatch = interrupt;
  }

  cancel(mappers) {
    this.matchBlocked = this.Utils.blockMatch(mappers);
    this.interruptToMatch = null;
  }

  saveInterruptMatch(interrupt, d365interrupt, mappers) {
    this.state = "loading";
    this.D365.saveInterrupttMapper(
      interrupt.interruptId,
      angular.fromJson(d365interrupt).d365InterruptId,
      angular.fromJson(d365interrupt).d365InterruptName,
      angular.fromJson(d365interrupt).d365HierarchyId,
      interrupt.appliesToClient
    ).then(
      () => {
        this.interruptToMatch = null;
        this.refresh(mappers);
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(mappers);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  refresh(mappers) {
    this.getData();
    this.matchBlocked = this.Utils.blockMatch(mappers);
  }

  deleteInterrupt(entity, mappers) {
    this.state = "loading";
    this.D365.deleteInterruptMapper(entity.interruptId, entity.appliesToClient).then(
      () => {
        this.refresh(mappers);
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  displayInterruptFn(item) {
    return `${item.d365InterruptId ? item.d365InterruptId + ' - ' : ''}${item.d365HierarchyId ? item.d365HierarchyId + ' - ' : ''}${item.d365InterruptName || ''}`;
  }
}
